export default __webpack_public_path__ + "static/media/avion.3b286584.svg";